import * as React from 'react';

import Tabs from 'src/components/common/Tabs';

interface IProps {
	className?: string;
	location?: any;
	organizationId: string;
	locationId: string;
	match?: any;
}

const LocationTabs: React.FC<IProps> = props => {

	const { locationId } = props.match.params;
	const tabs = [
		{
			to: `/admin/organizations/${props.organizationId}/locations/${props.locationId}`,
			label: 'Details',
		},
	];

	if (Number(locationId > 0)) {
		tabs.push({
			to: `/admin/organizations/${props.organizationId}/locations/${props.locationId}/courses`,
			label: 'Courses'
		});
	}

	return (
		<Tabs
			className={props.className}
			tabs={tabs}
			location={props.location}
		/>
	);
};

export default LocationTabs;